export default __webpack_public_path__ + "static/media/rings-bg.a16a7399.png";